module.exports = __webpack_public_path__ + "img/top-health-beauty-bg.7481ce0.jpg";